// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".customBorder[data-v-713eb2c5]{width:100%;border-bottom:1px solid #dbdee3}.customBorder[data-v-713eb2c5]:before{content:\"\";position:absolute;width:20px;left:-20px;border-bottom:1px solid #dbdee3}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
